import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang, servicePath } from "../i18n";
import { Reveal } from "./Reveal";

// Architectural service card: champagne number, thin border, editorial type.
// tone: "light" (on ivory) | "dark" (on carbon)
const ServiceCard = ({ service, tone = "light", delay = 0 }) => {
  const { lang, t } = useLang();
  const s = service[lang];
  const light = tone === "light";

  return (
    <Reveal delay={delay}>
      <Link
        to={servicePath(lang, service.slug)}
        data-testid={`service-card-${service.slug}`}
        className={`group relative flex h-full flex-col border p-8 transition-all duration-300 hover:-translate-y-1.5 sm:p-10 ${
          light
            ? "border-[#171717]/12 bg-[#F4F0E8] hover:border-[#C6A46A]"
            : "border-[#F4F0E8]/12 bg-[#1E1E1E] hover:border-[#C6A46A]"
        }`}
      >
        <span className="absolute left-0 top-0 h-px w-10 bg-[#C6A46A] transition-all duration-500 group-hover:w-full" />
        <span className="text-4xl font-light text-[#C6A46A]">{service.num}</span>
        <h3
          className={`mt-8 text-lg font-light uppercase tracking-[0.12em] sm:text-xl ${
            light ? "text-[#171717]" : "text-[#F4F0E8]"
          }`}
        >
          {s.title}
        </h3>
        <p className={`mt-4 flex-1 text-sm leading-relaxed ${light ? "text-[#171717]/65" : "text-[#F4F0E8]/60"}`}>
          {s.short}
        </p>
        <span
          className={`mt-8 inline-flex items-center gap-2 text-[0.65rem] font-medium uppercase tracking-[0.18em] transition-colors ${
            light ? "text-[#171717]/70 group-hover:text-[#8a6f3e]" : "text-[#F4F0E8]/70 group-hover:text-[#C6A46A]"
          }`}
        >
          {t.common.learnMore}
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </Link>
    </Reveal>
  );
};

export default ServiceCard;
